import { useIntl } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { Collapse, Divider, IconButton, Stack } from '@mui/material';

import { SizingMultiplier, Typography } from '@ocx/ui';

import { pointExpirationScheduleMessages } from '../point-expiration-schedule.messages';
import { usePointsExpiringSoon } from '../hooks/use-points-expiring-soon.hook';

export type ExpiringPointsData = {
  totalExpiringPoints: number;
  loading: boolean;
  isPointExpirationEnabled: boolean;
};

export type PointExpirationBannerProps = {
  handleClickToPointExpirationPage: () => void;
};

export const PointExpirationBanner = (props: PointExpirationBannerProps) => {
  const { handleClickToPointExpirationPage } = props;
  const intl = useIntl();

  const { shouldShowExpiringPoints, handleManualDismissal } = usePointsExpiringSoon();

  return (
    <Collapse in={shouldShowExpiringPoints} timeout={500}>
      <Divider />
      <Stack alignItems="center" direction="row" py={SizingMultiplier.xs}>
        <Typography
          variant="body2"
          component="span"
          color="error.main"
          fontWeight="600"
          onClick={handleClickToPointExpirationPage}
          sx={{
            flex: 1,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: SizingMultiplier.sm,
          }}>
          <ErrorIcon color="error" />

          {intl.formatMessage(pointExpirationScheduleMessages['point-expiration-schedule:expiring-soon-banner'])}
        </Typography>

        <IconButton onClick={handleManualDismissal}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Collapse>
  );
};
